import { render, staticRenderFns } from "./sns-validate.vue?vue&type=template&id=3d000438&"
import script from "./sns-validate.vue?vue&type=script&lang=js&"
export * from "./sns-validate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports